import React, { useState } from 'react';
import MobileS from "../../assets/images/mobileS.png";
import MobileM from "../../assets/images/mobileM.png";
import MobileL from "../../assets/images/mobileL.png";
import Tablet from "../../assets/images/tablet.png";
import Laptop from "../../assets/images/laptop.png";
import LaptopL from "../../assets/images/laptopL.png";
import Desktop from "../../assets/images/DESKTOP.png";
import ourVisionImg from "../../assets/images/vision.gif";
import ResidentThumbnail from '../../assets/images/Resident-Thumbnail.png';  // your file
import DeliveryThumbnail from '../../assets/images/delivery-thumbnail.png';

const AboutSection = () => {
  const [active, setActive] = useState('resident');
  const residentVideo = "https://tmw-storage.s3.ap-south-1.amazonaws.com/TMW-Kiosk/tmw_multimedia_assets/videos/Resident_compressed_.mp4";
  const deliveryVideo = "https://tmw-storage.s3.ap-south-1.amazonaws.com/TMW-Kiosk/tmw_multimedia_assets/videos/Delivery_Manual_Final_with3D_update_compressed.mp4";
  const getVideoSrc = () => {
    return active === 'resident' ? residentVideo : deliveryVideo;
  };

  return (
    <>
      <section className="relative w-full h-[500px] my-[100px] mobileS:h-[501.56px] mobileM:h-[587px] mobileL:h-[666.13px] tablet:h-[1133px] laptop:h-[650px] laptopL:h-[850px] desktop:h-[850px] overflow-hidden">
        {/* Mobile XS - S */}
        <div className="block mobileS:hidden absolute inset-0 z-0">
          <img src={MobileS} alt="Mobile XS" className="w-full h-full object-contain object-top" />
        </div>

        <div className="hidden mobileS:block mobileM:hidden absolute inset-0 z-0">
          <img src={MobileS} alt="Mobile S" className="w-full h-full object-fill object-top" />
        </div>

        {/* Mobile M */}
        <div className="hidden mobileM:block mobileL:hidden absolute inset-0 z-0">
          <img src={MobileM} alt="Mobile M" className="w-full h-full object-fill object-top" />
        </div>

        {/* Mobile L */}
        <div className="hidden mobileL:block tablet:hidden absolute inset-0 z-0">
          <img src={MobileL} alt="Mobile L" className="w-full h-full object-fill object-top" />
        </div>

        {/* Tablet */}
        <div className="hidden tablet:block laptop:hidden absolute inset-0 z-0">
          <img src={Tablet} alt="Tablet" className="w-full h-full object-cover" />
        </div>

        {/* Laptop */}
        <div className="hidden laptop:block laptopL:hidden absolute inset-0 z-0">
          <img
            src={Laptop}
            alt="Laptop"
            className="w-full h-full object-cover laptop:object-[100%_100%] laptopL:object-cover"
          />
        </div>

        {/* Laptop L */}
        <div className="hidden laptopL:block desktop:hidden absolute inset-0 z-0">
          <img
            src={LaptopL}
            alt="Laptop L"
            className="w-full h-full object-cover laptopL:object-[100%_100%] desktop:object-cover"
          />
        </div>

        {/* Desktop */}
        <div className="hidden desktop:block absolute inset-0 z-0">
          <img src={Desktop} alt="Desktop" className="w-full h-full object-cover" />
        </div>

        {/* Text content */}
        <div className="relative w-full h-full">
          {/* Heading for Desktop & Laptop */}
          <div
            className="absolute text-white text-center hidden lg:block left-1/2 transform -translate-x-1/2"
            style={{
              width: "571.78px",
              height: "102.58px",
              top: "100px",
            }}
          >
            <h3
              className="font-dongle leading-none"
              style={{
                fontSize: "148px",
                lineHeight: "1",
              }}
            >
              Who We Are?
            </h3>
          </div>

          {/* Desktop Text Box */}
          <div
            className="absolute hidden lg:block left-1/2 transform -translate-x-1/2"
            style={{
              width: "90vw",
              maxWidth: "1032.94px",
              height: "426.38px",
              top: "267.58px",
              backgroundColor: "#FFFFFF0F",
              borderRadius: "53.52px",
              border: "0.89px solid #FFFFFF",
              boxSizing: "border-box",
            }}
          >
            <div
              className="absolute text-[#FDFEFF]"
              style={{
                width: "88%",
                maxWidth: "912.52px",
                height: "212px",
                left: "50%",
                transform: "translateX(-50%)",
                top: "56.2px",
                fontFamily: "Alata, sans-serif",
                fontSize: "21px",
                lineHeight: "42px",
                textAlign: "center",
              }}
            >
              The Mail Whale is a comprehensive solution for enhancing the security of last step 
              parcel delivery. We combine end-to-end encryption and real-time user interfaces. Our 
              mission is to deliver every package with precision, safety—empowering users with seamless 
              control over their deliveries.
            </div>

            <div
              className="absolute text-[#FDFEFF]"
              style={{
                width: "187.9px",
                height: "50.84px",
                left: "50%",
                transform: "translateX(-50%)",
                top: "303px",
                fontFamily: "Alata, sans-serif",
                fontSize: "20px",
                lineHeight: "28px",
                textAlign: "center",
                opacity: 0.5,
              }}
            >
              - The Mail Whale
            </div>
          </div>

          {/* Responsive for Tablet, Laptop (below lg), and Mobile */}
<div className="lg:hidden w-full px-4 sm:px-6 md:px-8 pt-4 sm:pt-10 pb-4 flex flex-col items-center justify-center text-center tablet:mt-[150px] mobileM:mt-[110px] mobileL:mt-[100px]">
  <h3 className="font-dongle text-white text-[32px] sm:text-[50px] md:text-[80px] lg:text-[100px] mt-[20px] sm:mt-[60px] md:mt-[80px] leading-none mb-3 sm:mb-6 md:mb-8">
    Who We Are?
  </h3>
  <div className="w-full sm:max-w-[600px] md:max-w-[750px] bg-white/10 border border-white rounded-[24px] p-4 sm:p-8 md:p-10 mx-4 sm:mx-6 md:mx-8 mobileM:w-[320px] mobileM:h-auto mobileL:w-[500px] mobileL:h-auto" style={{ boxSizing: "border-box" }}>
    <p className="font-alata text-[#FDFEFF] text-[14px] sm:text-[18px] md:text-[20px] leading-[22px] sm:leading-[30px] md:leading-[34px]">
      The Mail Whale is a comprehensive solution for enhancing the security of last step parcel delivery. We combine end-to-end encryption and real-time user interfaces. Our mission is to deliver every package with precision, safety—empowering users with seamless control over their deliveries.
    </p>
    <span className="block mt-2 sm:mt-4 md:mt-6 text-[#FDFEFF] opacity-50 text-[14px] sm:text-[18px] md:text-[20px] leading-tight">
      - The Mail Whale
    </span>
  </div>
</div>
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="vision w-full bg-no-repeat pt-6 pb-12 mb-[200px] md:pt-[107px] md:pb-[107px] md:mb-[107px]">
        <div className="container mx-auto px-4">
          {/* Outer White Container */}
          <div className="bg-white rounded-[30px] shadow-[0px_3.71px_161.8px_0px_#1797ffa6] border-4 border-transparent overflow-hidden w-full max-w-[1470.57px] mx-auto min-h-[500.7px] flex justify-center items-center p-6">
            {/* Inner Flex Container */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-[64px] w-full max-w-[1256.86px] min-h-[358.31px]">
              {/* Left GIF */}
              <div className="flex justify-center items-center w-full md:w-[524.68px] bg-white">
                <img
                  src={ourVisionImg}
                  alt="our vision"
                  className="
                    w-[280px] h-[220px]          /* Mobile size */
                    sm:w-[340px] sm:h-[260px]    /* Small devices */
                    md:w-[624.68px] md:h-[542px] /* Desktop exact size */
                    object-contain
                  "
                />
              </div>

              {/* Right Text */}
              <div className="w-full md:w-[668.18px] min-h-[358.31px] flex flex-col justify-center text-center md:text-left">
                <h3 className="pb-3 font-alata text-[28px] sm:text-[36px] md:text-[52px] lg:text-[68px] xl:text-[87px] leading-tight font-normal text-[#2699FF]">
                  Our Vision
                </h3>
                <p className="font-alata text-[15px] sm:text-[18px] md:text-[22px] lg:text-[25px] leading-relaxed font-normal text-[#000]">
                  We imagine a future where sending a parcel is as simple as sending a message—instant,
                  secure, and worry-free. By blending autonomous and human connections, TMW is creating a 
                  new standard in making every delivery intuitive and trusted connection.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Products Section */}
      <section id="demo-video" className="w-full max-w-[1920px] mx-auto bg-white px-4 sm:px-6 md:px-8 py-6 -mt-[100px] md:mt-[107px]">
        <div className="w-full max-w-[1211.62px] mx-auto flex flex-col">
          {/* Header Section */}
          <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center gap-4 md:gap-0">
            <h2 className="font-dongle font-normal text-[48px] sm:text-[64px] md:text-[78px] lg:text-[92.22px] leading-tight text-[#004990] capitalize text-center md:text-left">
              Our Product
            </h2>

            <div className="flex flex-row items-center justify-center gap-[8.74px]">
              <button
                onClick={() => setActive('resident')}
                className={`w-[156.77px] h-[43.34px] rounded-[137.15px] px-[8.74px] py-[8.74px] border font-semibold transition 
                  ${active === 'resident' ? 'bg-[#004990] text-white' : 'bg-white text-[#004990] border-[#004990]'}`}
              >
                RESIDENT
              </button>
                
              <button
                onClick={() => setActive('delivery')}
                className={`w-[156.77px] h-[43.34px] rounded-[137.15px] px-[8.74px] py-[8.74px] border font-semibold transition 
                  ${active === 'delivery' ? 'bg-[#004990] text-white' : 'bg-white text-[#004990] border-[#004990]'}`}
              >
                DELIVERY
              </button>
            </div>
          </div>

          {/* Video Section */}
            <div className="mt-6 w-full">
              <video
                key={active} 
                controls
                className="w-full max-h-[672.11px] object-cover rounded-lg shadow-lg"
                poster={active === 'resident' ? ResidentThumbnail : DeliveryThumbnail}
                preload="metadata"
              >
                <source src={getVideoSrc()} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
